import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStore(ctx){
        return new Promise((resolve, reject) => {
            axiosIns.get('/store/'+getUserData().store_id)
            .then(response=>resolve(response))
            .catch(error=>reject(error))
        })
    },
    updateIcon(ctx, data) {
        return new Promise((resolve, reject) => {
            axiosIns.post('/store/updateIcon', data,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
            )
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
    },

  },
}
